"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _advertiseManage = require("@/api/_homeCloudPlatform/advertise/advertiseManage.js");
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _articleManage = require("@/api/_homeCloudPlatform/article/articleManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { domain } from '../../../_config'

var formModel = {
  type: 1
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        name: [{
          required: true,
          message: '请输入名称'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        on_shelf_time: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (_this.on_shelf_time === null || !_this.on_shelf_time[0] || !_this.on_shelf_time[1]) {
              callBack('请选择上架时间');
            } else {
              callBack();
            }
          }
        },
        'previewImg': {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (!_this.previewImg.image) {
              callBack('请选择图片');
            } else {
              callBack();
            }
          }
        },
        news_link: [{
          required: true,
          message: '请选择链结文章'
        }],
        goods_link: [{
          required: true,
          message: '请选择链结商品'
        }],
        sorting: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 > 9999) {
              callBack('输入的数字不应大于9999');
            } else {
              callBack();
            }
          }
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u5E7F\u544A");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依創建時間遞減
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20,
        status: '',
        type: ''
      },
      dialogVisible: false,
      dialogType: 'view',
      // 狀態選項
      statusOptions: [{
        key: 'all',
        display_name: '全部',
        value: 'all'
      }, {
        key: 'true',
        display_name: '上架',
        value: true
      }, {
        key: 'false',
        display_name: '下架',
        value: !true
      }],
      // 類型選項
      typeOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '商城主广告'
      }, {
        key: 2,
        display_name: '首页主广告'
      }],
      // 廣告類型
      advertiseTypeOptions: [{
        key: 1,
        display_name: '商城主广告(375*220)'
      }, {
        key: 2,
        display_name: '首页主广告(375*220)'
      }],
      // 链结商品
      linkedProductsOptions: [],
      // 链结文章
      linkedNNewsOptions: [],
      previewImg: {},
      on_shelf_time: null
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.handleSort();
            _context.next = 3;
            return this.getGoodsList();
          case 3:
            _context.next = 5;
            return this.getNewsList();
          case 5:
            this.getList();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    checkPermission: _permission.default,
    getGoodsList: function () {
      var _getGoodsList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _commodityManage.getGoodsList)({
                product_status: 1,
                page: 1,
                page_size: 1
              }).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(data) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (data.count) {
                          _context2.next = 2;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 2:
                        _context2.next = 4;
                        return (0, _commodityManage.getGoodsList)({
                          product_status: 1,
                          page_size: data.count
                        }).then(function (res) {
                          _this2.linkedProductsOptions = res.results;
                        });
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getGoodsList() {
        return _getGoodsList2.apply(this, arguments);
      }
      return getGoodsList;
    }(),
    getNewsList: function () {
      var _getNewsList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _articleManage.getNewsList)({
                status: true,
                page: 1,
                page_size: 1
              }).then(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(data) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (data.count) {
                          _context4.next = 2;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 2:
                        _context4.next = 4;
                        return (0, _articleManage.getNewsList)({
                          status: true,
                          page_size: data.count
                        }).then(function (res) {
                          _this3.linkedNewsOptions = res.results;
                        });
                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getNewsList() {
        return _getNewsList2.apply(this, arguments);
      }
      return getNewsList;
    }(),
    getList: function getList(e) {
      var _this4 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _advertiseManage.getAdvertisementList)(this.handleQuery()).then(function (response) {
        if (response.results) {
          _this4.tableData = response || [];
        }
        _this4.listLoading = false;
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size
      };
      this.getList();
    },
    handleView: function handleView(scope) {
      var _this5 = this;
      this.formModel = Object.assign({}, scope.row);
      this.handleInitData();
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    handleAdd: function handleAdd() {
      var _this6 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this6.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this7 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this7.$refs['Form'].clearValidate();
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _advertiseManage.updateAdvertisement)(_this8.formModel.id, _this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this8.dialogType === 'add') {
                    (0, _advertiseManage.createAdvertisement)(_this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirm(_x3) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this9 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          // 打API上傳圖片
          var formdata = new FormData();
          formdata.append('file', file);
          (0, _advertiseManage.createAdvertisementImage)(formdata).then(function (res) {
            _this9.previewImg = {
              // image: e.target.result, //直接讀取
              image: "".concat(res.data.urls),
              //從API res讀取
              path: "".concat(res.data.path)
            };
          });
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeImg: function removeImg() {
      this.previewImg = {};
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      // 狀態
      if (query.status === '' || query.status === 'all') {
        query.status = function () {
          return;
        }();
      }
      // 類型
      if (query.type === '' || query.type === 'all') {
        query.type = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // 初始化資料處理
    handleInitData: function handleInitData() {
      this.previewImg = {};
      // 上架時間
      this.on_shelf_time = [this.formModel.on_shelf_start || '', this.formModel.on_shelf_end || ''];
      // 圖片
      this.previewImg = {
        image: this.formModel.image_url
      };
    },
    handleFormData: function handleFormData() {
      var _this10 = this;
      if (this.on_shelf_time) {
        this.formModel.on_shelf_start = this.on_shelf_time[0];
        this.formModel.on_shelf_end = this.on_shelf_time[1];
      }
      if (this.previewImg.path) {
        this.formModel.image = this.previewImg.path;
      }
      var _this$formModel = this.formModel,
        name = _this$formModel.name,
        type = _this$formModel.type,
        goods_link = _this$formModel.goods_link,
        news_link = _this$formModel.news_link,
        sorting = _this$formModel.sorting,
        _this$formModel$on_sh = _this$formModel.on_shelf_start,
        on_shelf_start = _this$formModel$on_sh === void 0 ? '' : _this$formModel$on_sh,
        _this$formModel$on_sh2 = _this$formModel.on_shelf_end,
        on_shelf_end = _this$formModel$on_sh2 === void 0 ? '' : _this$formModel$on_sh2,
        _this$formModel$image = _this$formModel.image,
        image = _this$formModel$image === void 0 ? '' : _this$formModel$image;
      var params = {
        name: name,
        type: type,
        sorting: sorting,
        image: image,
        on_shelf_start: on_shelf_start,
        on_shelf_end: on_shelf_end,
        news_link: function () {
          if (_this10.formModel.type == '2') return _this10.formModel.news_link;
          return;
        }(),
        goods_link: function () {
          if (_this10.formModel.type == '1') return _this10.formModel.goods_link;
          return;
        }(),
        status: function () {
          if (_this10.dialogType === 'edit') return _this10.formModel.status;
          return;
        }()
      };
      return params;
    }
  }
};